<template>
<multi-select :value="value" @input="update" :label="label" :filter="filter" 
              url="cities" placeholder="Wähle einen Ort aus">
    <span slot="noResult">
        Keine Orte gefunden
    </span>
</multi-select>
</template>

<script>
import _ from 'underscore'
import multiSelect from 'components/multi-select.vue'

export default {
	components: { multiSelect },
	props: [ 'value' ],
	methods: {
		label ({ postal_code, name }) {
            return `${postal_code} ${name}`
        },
        filter (city, query) {
            return city.postal_code.toString().indexOf(query) === 0 ||
                    city.name.toLowerCase().indexOf(query) != -1
        },
        update (value, id) {
            this.$emit('input', value)
        }
	}
}
</script>


// WEBPACK FOOTER //
// city-select.vue?fdc77a0a